import { MockedVdd } from '@vi-iot/client/apis/remote-diagnostics/mocked-vdds/MockedVdd.model';
import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '@vi-iot/client';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class MacAddressLan implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES: ' 62 02 50 E0 91 53 A8 47 99',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0024_EMCU_CAN71',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0024_EMCU_CAN71',
      request_parameter_value: VddNames.MacAddressLan,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'MacAddressLan',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'MAC',
              path: 'PA_DataRecor/PA_Mac1',
              unit: '',
              translationid: 'TI_Mac_1',
              dopname: '1 Byte Identical uint8 Hex',
              name: 'PA_Mac1',
              value: '224',
            },
            {
              semantic: 'MAC',
              path: 'PA_DataRecor/PA_Mac2',
              unit: '',
              translationid: 'TI_Mac_2',
              dopname: '1 Byte Identical uint8 Hex',
              name: 'PA_Mac2',
              value: '145',
            },
            {
              semantic: 'MAC',
              path: 'PA_DataRecor/PA_Mac3',
              unit: '',
              translationid: 'TI_Mac_3',
              dopname: '1 Byte Identical uint8 Hex',
              name: 'PA_Mac3',
              value: '83',
            },
            {
              semantic: 'MAC',
              path: 'PA_DataRecor/PA_Mac4',
              unit: '',
              translationid: 'TI_Mac_4',
              dopname: '1 Byte Identical uint8 Hex',
              name: 'PA_Mac4',
              value: '168',
            },
            {
              semantic: 'MAC',
              path: 'PA_DataRecor/PA_Mac5',
              unit: '',
              translationid: 'TI_Mac_5',
              dopname: '1 Byte Identical uint8 Hex',
              name: 'PA_Mac5',
              value: '71',
            },
            {
              semantic: 'MAC',
              path: 'PA_DataRecor/PA_Mac6',
              unit: '',
              translationid: 'TI_Mac_6',
              dopname: '1 Byte Identical uint8 Hex',
              name: 'PA_Mac6',
              value: '153',
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 02 50',
    };
  }
  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0024_EMCU_CAN71',
      request_parameter_value: VddNames.MacAddressLan,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '592',
          value: 'MacAddressLan',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }
  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0024_EMCU_CAN71',
          request_parameter_value: VddNames.MacAddressLan,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '592',
              value: 'MacAddressLan',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'MAC',
                  longname: 'Mac-1',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8 Hex',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Mac1',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_Mac1',
                  unit: '',
                  translationid: 'TI_Mac_1',
                  bitposition: '0',
                  name: 'PA_Mac1',
                  value: '0',
                },
                {
                  semantic: 'MAC',
                  longname: 'Mac-2',
                  byteposition: '1',
                  dopname: '1 Byte Identical uint8 Hex',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Mac2',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_Mac2',
                  unit: '',
                  translationid: 'TI_Mac_2',
                  bitposition: '0',
                  name: 'PA_Mac2',
                  value: '0',
                },
                {
                  semantic: 'MAC',
                  longname: 'Mac-3',
                  byteposition: '2',
                  dopname: '1 Byte Identical uint8 Hex',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Mac3',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_Mac3',
                  unit: '',
                  translationid: 'TI_Mac_3',
                  bitposition: '0',
                  name: 'PA_Mac3',
                  value: '0',
                },
                {
                  semantic: 'MAC',
                  longname: 'Mac-4',
                  byteposition: '3',
                  dopname: '1 Byte Identical uint8 Hex',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Mac4',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_Mac4',
                  unit: '',
                  translationid: 'TI_Mac_4',
                  bitposition: '0',
                  name: 'PA_Mac4',
                  value: '0',
                },
                {
                  semantic: 'MAC',
                  longname: 'Mac-5',
                  byteposition: '4',
                  dopname: '1 Byte Identical uint8 Hex',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Mac5',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_Mac5',
                  unit: '',
                  translationid: 'TI_Mac_5',
                  bitposition: '0',
                  name: 'PA_Mac5',
                  value: '0',
                },
                {
                  semantic: 'MAC',
                  longname: 'Mac-6',
                  byteposition: '5',
                  dopname: '1 Byte Identical uint8 Hex',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Mac6',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_Mac6',
                  unit: '',
                  translationid: 'TI_Mac_6',
                  bitposition: '0',
                  name: 'PA_Mac6',
                  value: '0',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
